import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/pro-light-svg-icons";
import { Row, Col } from "react-bootstrap";

const RequestSummaryCard = (props) => {
  const {
    label = "",
    count = 0,
    color = "#F19937",
    backgroundColor = "rgba(241, 153, 55, 0.1)",
    raiseNewRequest = false,
  } = props;
  return (
    <div
      style={{
        color: color,
        background: backgroundColor,
        borderRadius: "5px",
        border: raiseNewRequest
          ? `0.5px dashed ${color}`
          : `0.5px solid ${color}`,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "150px",
      }}
    >
      <div
        style={{
          fontWeight: "500",
          fontSize: "12px",
          color: "#777777",
          textAlign: "center",
        }}
      >
        {label}
      </div>
      <>
        {raiseNewRequest ? (
          <div style={{ fontSize: "60px", fontWeight: "300" }}>
            <FontAwesomeIcon icon={faPlusCircle} />{" "}
          </div>
        ) : (
          <div style={{ fontSize: "40px", fontWeight: "500" }}>{count}</div>
        )}
      </>
    </div>
  );
};

function RequestSummaryComponent(props) {
  return (
    <div
      style={{
        background: "white",
        width: "100%",
        borderRadius: "5px",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
        padding: "20px",
      }}
    >
      <div
        style={{ fontWeight: "500", fontSize: "16px", marginBottom: "20px" }}
      >
        Request Summary
      </div>
      <Row className="mb-3 mx-0" style={{ flexDirection: "space-between" }}>
        <Col md={6} className="pl-0">
          <RequestSummaryCard
            label="Incomplete Request"
            count={12}
            color="#F19937"
            backgroundColor="rgba(241, 153, 55, 0.1)"
          />
        </Col>
        <Col md={6} className="pr-0">
          <RequestSummaryCard
            label="Waiting For Approval"
            count={32}
            color="#EB4E3D"
            backgroundColor="rgba(235, 78, 61, 0.1)"
          />
        </Col>
      </Row>
      <RequestSummaryCard
        raiseNewRequest={true}
        label="Raise New Request"
        count={32}
        color="#307BF6"
        backgroundColor="rgba(48, 123, 246, 0.1)"
      />
    </div>
  );
}

export default RequestSummaryComponent;
